const exemptionJSON = localStorage.getItem("geoipExemptionData");
let exemptionData = null;
if (exemptionJSON) {
  exemptionData = JSON.parse(exemptionJSON);
}

// Caching variable to prevent duplicate fetch requests
let currentLocale = null;

// Store the element that triggered the modal (for focus management)
let lastFocusedElement = null;

// Returns user locale via geoip
async function getLocale() {
  if (currentLocale) return currentLocale;
  const res = await fetch("/browsing_context_suggestions.json");
  const { detected_values } = await res.json();
  currentLocale = detected_values.country.handle;
  return currentLocale;
}

// Handles the population of the geoip modal
async function showGeoipModal() {
  if (!hasExemptionExpired()) return; // If the user is exempt from geoip, don't show the modal

  const modal = document.getElementById("gdl-country-selector-modal");
  if (!modal) return;

  // If the modal opens automatically (e.g., after x seconds), save the <body> as the focus fallback
  if (!lastFocusedElement) {
    lastFocusedElement =
      document.activeElement === document.body ? null : document.activeElement;
  }

  // Handle modal close and focus return
  const modalCloseEls = modal.querySelectorAll("#ModalClose-btq");
  [...modalCloseEls].forEach((e) =>
    e.addEventListener("click", () => {
      modal.classList.remove("open");
      onModalClose();
    })
  );

  modal.setAttribute("open", "");
  document.documentElement.classList.add("overflow-hidden");
  modal.setAttribute("aria-hidden", "false");
}

// Sets the exemption data (when modal is closed or user action occurs)
function setExemptionData(isoCode = Shopify.country) {
  localStorage.setItem(
    "geoipExemptionData",
    JSON.stringify({ date: Date.now(), isoCode })
  );
}

// Handle modal close and focus return logic
async function onModalClose() {
  setExemptionData(Shopify.country);

  const modal = document.getElementById("gdl-country-selector-modal");

  // Return focus to the triggering element, or fallback to the <body> if auto-opened
  if (lastFocusedElement && document.contains(lastFocusedElement)) {
    lastFocusedElement.focus();
  } else {
    document.body.focus();
  }
}

// Handle automatic redirection for user currency
async function attemptCurrencyRedirect() {
  if (!hasExemptionExpired()) return; // No need to attempt a redirect if an exemption is still in place

  const userIsoCode = await getLocale();

  if (operatedCountries(userIsoCode)) return;

  const currentIsoCode = Shopify.country;

  if (userIsoCode === currentIsoCode) return; // If store is already correct there's no need to redirect

  setExemptionData(userIsoCode);
  performRedirect(userIsoCode);
}

function hasExemptionExpired() {
  if (!exemptionData) return true;

  const then = new Date(exemptionData.date);
  const now = new Date();
  const msBetweenDates = Math.abs(then.getTime() - now.getTime());
  const daysBetweenDates = msBetweenDates / (24 * 60 * 60 * 1000);
  if (daysBetweenDates < 30) return false;
  return true;
}

function shouldDisableGeoIP() {
  if (document.cookie.includes("GE_Replacement")) return true;

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  if (params.hasOwnProperty("replacementExpire")) return true;
  if (params.hasOwnProperty("startReplacement")) return true;

  return false;
}

async function handleDisableParam() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  if (params.hasOwnProperty("forceCountry")) {
    setExemptionData(params.forceCountry);
    return true;
  }

  if (params.hasOwnProperty("disableGeoIP")) {
    setExemptionData(Shopify.country);
    return true;
  }

  return false;
}

function redirectToStoredCurrency() {
  if (hasExemptionExpired()) return; // If the exemption has expired, skip this function
  let { isoCode, languageIsoCode } = exemptionData;
  if (
    isoCode && isoCode.toLowerCase() === Shopify.country.toLowerCase() &&
    languageIsoCode && languageIsoCode.toLowerCase() === Shopify.locale.toLowerCase()
  ) return; // Already on correct store
  if ('it' == isoCode.toLowerCase() && !languageIsoCode) return;
  if (!['it', 'jp'].includes(isoCode.toLowerCase())) {
    languageIsoCode = 'en';
    localStorage.removeItem("geoipExemptionData");
    localStorage.setItem('geoipExemptionData', JSON.stringify({
      date: Date.now(),
      isoCode: isoCode,
      languageIsoCode: languageIsoCode,
    }))
  }
  performRedirect(isoCode, languageIsoCode);
}

function operatedCountries(isoCode) {
  //Gets List of operated countries returns Array
  if (!window.GLBE_PARAMS) return;
  const operatedCountries = window.GLBE_PARAMS.operatedCountries;
  //If OperatedCountries does not include the userIsoCode
  if (!operatedCountries.includes(isoCode)) {
    //forces a redirect to the US store
    localStorage.removeItem("geoipExemptionData");
    return true;
  } else {
    return;
  }
}

function performRedirect(isoCode, languageIsoCode = null) {
  const form = document.querySelector("#country-picker form");
  if (!form) return;

  const country_code = document.querySelector('#country-picker input[name="country_code"]');
  const language_code = document.querySelector('#country-picker input[name="language_code"]');

  country_code.value = isoCode;
  language_code.value = languageIsoCode ? languageIsoCode : isoCode;
  
  const operatedCheck = operatedCountries(isoCode);
  if (operatedCheck) {
  } else {
    if (form) HTMLFormElement.prototype.submit.call(form);
  }
}

// IIFE (Immediately Invoked Function Expression) for handling GeoIP and modal behavior
(async () => {
  // Handle GeoIP disable query param
  const didUpdateExemptionData = await handleDisableParam();
  if (didUpdateExemptionData) return;

  // Skip GeoIP system entirely if Global E dashboard query parameter is present
  if (shouldDisableGeoIP()) return;

  redirectToStoredCurrency(); // Step 1 - if a currency is already stored, use that
  await attemptCurrencyRedirect(); // Step 2 - if no currency is stored and the user is on the correct store, attempt a GeoIP redirect
  await showGeoipModal(); // Step 3 - if the user is on the wrong store, show the store picker modal
})();
